import { UpdateHistoryResponse } from "@/hooks/usePrivateOfficeUpdateHistory";

interface WobaInventoryAuditLog {
  _id: string;
  created_at: string;
  action_description: string;
  executed_by_user_id: string | number | null;
  executed_by: string;
  target_entity: string;
  current_entity_data: Record<string, any>;
  previous_entity_data: Record<string, any>;
  executed_by_channel?: string;
  executed_by_api_endpoint?: string;
  affected_entity_id: string;
}

interface WobaInventoryPagination {
  page: number;
  take: number;
  total: number;
  pages: number;
  has_next_page: boolean;
  has_previous_page: boolean;
}

interface WobaInventoryResponse {
  audit_logs: WobaInventoryAuditLog[];
  pagination: WobaInventoryPagination;
}

export function adaptUpdateHistoryResponse(
  response: WobaInventoryResponse,
): UpdateHistoryResponse {
  return {
    audit_logs: response.audit_logs.map((log) => ({
      id: log._id,
      previous_entity_data: log.previous_entity_data || {},
      current_entity_data: log.current_entity_data || {},
      created_at: log.created_at,
      executed_by: log.executed_by || "Unknown",
      executed_by_user_id:
        log.executed_by_user_id != null
          ? String(log.executed_by_user_id)
          : null,
    })),
  };
}
